import { DeleteAccountDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
export const showDeleteAccountDialog = mountDialogUIReactComponent(DeleteAccountDialog);
